import { omit } from 'lodash';
import uuid from 'uuid/v4';

export const excludeProps = (object = {}, props = []) => omit(object, props);

export const cloneArrayList = () => {};

export const datePickerShortCutRanges = {
  ONE_WEEK: 3600 * 1000 * 24 * 7,
  ONE_MONTH: 3600 * 1000 * 24 * 30,
  THREE_MONTHS: 3600 * 1000 * 24 * 90,
};

export const isChoiceTemplate = item => 'choices' in item;

export const expandChoiceTemplate = template =>
  template.choices.map(c => ({ ...c, templateId: template.id }));

export const parseChoices = values =>
  values
    .map(value => {
      if (isChoiceTemplate(value)) {
        return expandChoiceTemplate(value);
      }
      return value;
    })
    .flatten();

export const emptyChoice = () => ({ id: uuid(), title: '' });



// WEBPACK FOOTER //
// ./src/components/surveybuilder/utils.js